<template>
  <div>
    <div>
      <span class="xbed-sub-title">{{title}}</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>广告设计</BreadcrumbItem>
        <BreadcrumbItem>{{title}}</BreadcrumbItem>
      </Breadcrumb>
    </div>


    <section class="add-wrapper">

    </section>

    <section>
      <Form :label-width="100" @submit.native.prevent="preventSubmit" inline>
        <FormItem label="终端位置：">
          <Select v-model="terminal" style="width:200px;" @on-change='prepareFilteredQuery'>
            <Option v-for="terminal in terminalTypes" v-bind:value="terminal.value" :key="terminal.label">{{terminal.label}}</Option>
          </Select>
        </FormItem>
        <FormItem label="文章栏目：">
          <Select v-model="column" style="width:200px;" @on-change='prepareFilteredQuery'>
            <Option v-for="column in columnTypes" v-bind:value="column.value" :key="column.label">{{column.label}}</Option>
          </Select>
        </FormItem>
        <FormItem label="类型：">
          <Select v-model="type" style="width:200px;" @on-change='prepareFilteredQuery'>
            <Option v-for="artcleType in artcleTypes" v-bind:value="artcleType.value" :key="artcleType.label">{{artcleType.label}}</Option>
          </Select>
        </FormItem>
        <FormItem label="标题：">
          <Input v-model="searchTitle" placeholder="请输入查询文章标题名称" icon="ios-search" @on-enter="prepareQueryWithKeyword" @on-click="prepareQueryWithKeyword"></Input>
        </FormItem>
        <FormItem>
          <Button type="info" @click="addArticle">添加文章</Button>
        </FormItem>
      </Form>
    </section>
    <Table border :columns="columns" :data="data"></Table>

    <section style="margin: 10px;overflow: hidden">
      <div style="float: left;">
        <Page show-sizer :total="count" :current="page" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
      </div>
    </section>
  </div>
</template>

<script>
import Utils from "../../utils";
import API from "../../api";
import Moment from "moment"

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config({
      top: 100
    });

    // 获取文章终端位置
    await this.getTermLocations()

    this.query();
  },
  data() {
    return {
      title: "文章管理",
      terminal: 0,
      column: 0,
      type: 0,
      searchTitle: "", // 模糊搜索标题
      count: 0,
      pageCount: 0,
      page: 1,
      pageSize: 10,
      loading: false,
      termLocations: {},
      terminalTypes: [
        {
          value: 0,
          label: "全部"
        },
        {
          value: 1,
          label: "Xbed官网"
        },
        {
          value: 2,
          label: "IOS"
        },
        {
          value: 3,
          label: "安卓"
        },
        {
          value: 4,
          label: "微信"
        },
        {
          value: 5,
          label: "PC电脑端"
        },
        // {
        //   value: 6,
        //   label: "PC电脑端"
        // }
      ],
      columnTypes: [
        {
          value: 0,
          label: "全部"
        },
        {
          value: 1,
          label: "集团动态"
        },
        {
          value: 2,
          label: "媒体报道"
        }
      ],
      artcleTypes: [
        {
          value: 0,
          label: "全部"
        },
        {
          value: 1,
          label: "新闻动态"
        },
        {
          value: 2,
          label: "旅游攻略"
        },
        {
          value: 3,
          label: "丽家会培训"
        },
        {
          value: 4,
          label: "其他"
        },
        {
          value: 5,
          label: "房客体验"
        },
        {
          value: 6,
          label: "房东故事"
        },
        {
          value: 7,
          label: "房客故事"
        },
        {
          value: 8,
          label: "Xbedlnn旗舰店"
        }
      ],
      columns: [
        {
          title: "ID",
          key: "articleId",
          width: 100
        },
        {
          title: "文章标题",
          key: "title",
          width: 200
        },
        {
          title: "网址链接",
          width: 500,
          render: (h, params) => {
            let typeName = "";
            switch (params.row.type) {
              case 0:
                break;
              case 1:
                typeName = "news";
                break;
              case 2:
                typeName = "travelGuide";
                break;
              case 3:
                typeName = "training";
                break;
              default: // 其他
                typeName = "others";
                break;
            }
            console.info(typeName)
            
            let url = typeName ? this.genLink(typeName, params.row.articleId) : '';
            return h(
              "a",
              {
                attrs: {
                  href: url,
                  target: "_blank"
                }
              },
              url
            );
          }
        },
        {
          title: "创建时间",
          key: "createDate",
          width: 300,
          render: (h, params) => {
            let createDate = Moment(params.row.createDate).format('YYYY-MM-DD HH:mm:ss');
            return h("div", {}, createDate);
          }
        },
        {
          title: "文章类型",
          width: 200,
          render: (h, params) => {
            return h("div", {}, this.artcleTypes[params.row.type].label);
          }
        },
        {
          title: "终端位置",
          width: 200,
          render: (h, params) => {
            let terminalTxt = [];
            if (params.row.type === 2 || params.row.type === 6 || params.row.type === 7 || params.row.type === 8) { // type（旅游攻略、房东故事、房客故事）
              const terminalArr = params.row.terminal.split(',');
              for (let i=0; i<terminalArr.length; i++) {
                let terminal = this.termLocations[terminalArr[i]];
                terminalTxt.push(terminal);
              }
            }else{
              let terminal = this.termLocations[params.row.terminal];
              terminalTxt.push(terminal);
            }
            return h("div", {}, terminalTxt.join(','));
          }
        },
        {
          title: "文章栏目",
          width: 200,
          render: (h, params) => {
            let column = '';
            if (params.row.type === 1) {
              column = this.columnTypes[params.row.column].label
            }
            return h("div", {}, column);
          }
        },
        {
          title: "状态",
          key: "status",
          width: 200,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const color = row.status === 1 ? "green" : "red";
            const text = row.status === 1 ? "开启" : "关闭";

            return h(
              "Tag",
              {
                props: {
                  type: "dot",
                  color: color
                }
              },
              text
            );
          }
        },
        {
          title: "操作",
          width: 280,
          align: "center",
          key: "id",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginRight: "10px"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.articleId, params.index);
                    }
                  }
                },
                "删除"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "10px"
                  },
                  on: {
                    click: () => {
                      this.editArticle(params.row.articleId);
                    }
                  }
                },
                "修改"
              )
            ]);
          }
        }
      ],
      data: [],
      websiteUrls: {
        dev: {
          url: "https://localhost:4201/",
          newsPath: "news/",
          trainingPath: "mobile/cleaner/training/",
          travelGuidePath: "mobile/travel/",
          othersPath: "others/",
        },
        ljhtest: {
          url: "https://statictest.xbed.com.cn/",
          newsPath: "news/",
          trainingPath: "mobile/cleaner/training/",
          travelGuidePath: "mobile/travel/",
          othersPath: "others/",
        },
        stagingk8s: {
          url: "https://staticpre.xbed.com.cn/",
          newsPath: "news/",
          trainingPath: "mobile/cleaner/training/",
          travelGuidePath: "mobile/travel/",
          othersPath: "others/",
        },
        productionk8s: {
          url: "https://static.xbed.com.cn/",
          newsPath: "news/",
          trainingPath: "mobile/cleaner/training/",
          travelGuidePath: "mobile/travel/",
          othersPath: "others/",
        }
      }
    };
  },
  methods: {
    changePage(pageIndex) {
      this.page = pageIndex;
      this.query();
    },
    changePageSize(pageSize) {
      this.page = 1;
      this.pageSize = pageSize;
      this.query();
    },
    // 关键字查询
    prepareQueryWithKeyword() {
      this.page = 1;
      this.query();
    },
    prepareFilteredQuery() {
      this.page = 1;
      this.searchTitle = "";
      this.query();
    },
    // 删除文章
    remove(articleId, index) {
      this.$Modal.confirm({
        title: "提示",
        content: "确定删除此文章？",
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          let resp = (await API.omsAPI[this.env].advert.deleteArticle(
            articleId,
            this.username,
            this.token
          )).data;
          if (resp.retCode) {
            // 失败
            this.$Notice.error({
              title: "删除文章失败",
              desc: resp.msg
            });
          } else {
            // 成功
            this.$Notice.success({
              title: "操作成功"
            });
            this.data.splice(index, 1);
          }
        }
      });
    },
    // 置顶文章
    async toTop(articleId, index, top) {
      let resp = (await API.omsAPI[this.env].advert.topArticle(
        articleId,
        top,
        this.username,
        this.token
      )).data;
      if (resp.retCode) {
        // 失败
        this.$Notice.error({
          title: "置顶文章失败",
          desc: resp.msg
        });
      } else {
        // 成功
        this.$Notice.success({
          title: "操作成功"
        });
        top ? (this.data[index].isTop = 1) : (this.data[index].isTop = 0);
      }
    },
    /**
     * @param typeName 文章类型( 新闻 news  培训资料 training 旅游攻略 travelGuide)
     */
    genLink(typeName, articleId) {
      const websiteUrlConfig = this.websiteUrls[this.env];
      console.info(websiteUrlConfig)
      console.info(websiteUrlConfig[`${typeName}Path`])
      return `${websiteUrlConfig.url}${websiteUrlConfig[`${typeName}Path`]}${articleId}`;
    },
    // 添加、编辑文章
    addArticle() {
      this.gotoEditPage();
    },
    editArticle(atricleId) {
      this.gotoEditPage(atricleId);
    },
    gotoEditPage(articleId) {
      if (this.$router) {
        this.$router.push({
          path: "/app/advert/articleEdit",
          query: { atricleId: articleId ? articleId : "" }
        });
      } else {
        window.open(
          `#/Advert/Advert/articleEdit?atricleId=${articleId ? articleId : ""}`,
          "_blank"
        );
      }
    },
    async query() {
      this.loading = true;

      let params = {
        column: this.column === 0 ? null : this.column,
        page: this.page,
        pageSize: this.pageSize,
        terminal: this.terminal === 0 ? null : this.terminal,
        title: this.searchTitle,
        type: this.type === 0 ? null : this.type
      }

      params = Utils.deleteEmptyProperty(params)

      console.info(params);

      let resp = (await API.omsAPI[this.env].advert.queryArticleList(params, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询文章列表失败",
          desc: resp.msg
        });
        return;
      }

      this.data = resp.result;
      this.page = resp.page;
      this.pageSize = resp.pageSize;
      this.pageCount = resp.pageCount;
      this.count = resp.count;
      this.loading = false;
    },
    // 获取文章终端位置接口
    getTermLocations () {
      return new Promise(async (resvole, reject) => {
        // 获取文章终端接口
        const selectiveResp = (await API.omsAPI[this.env].advert.getArticleSelective({}, this.token)).data;

        if (selectiveResp.retCode) {
          this.$Notice.error({
            title: "获取文章列表终端位置失败",
            desc: selectiveResp.msg
          });
          reject()
        }

        // 生成终端位置
        selectiveResp.terminals.map((terminal) => {
          this.termLocations[terminal.terminalId] = terminal.terminalName
        })
        resvole()
      })
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
  }
};
</script>

<style lang="scss" scoped>
.add-wrapper {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/advert/article-list.vue